module.exports = __webpack_public_path__ + "assets/img/11_941.15842c04.jpg";